import {
  Breakpoints,
  DesignTokenSize,
  styled,
} from '@volkswagen-onehub/components-core';

interface AutoScrollInnerProps {
  activeSlideOffsetLeft: number;
  slideWidthMobile: number;
  slideWidthDesktop: number;
  gapMobile: DesignTokenSize;
  gapDesktop: DesignTokenSize;
  childrenCount: number;
}

export const StyledAutoScrollContainer = styled.div`
  display: block;
  overflow: hidden;
`;

export const AutoScrollInner = styled.div<AutoScrollInnerProps>(
  ({
    theme,
    activeSlideOffsetLeft,
    gapMobile,
    gapDesktop,
    slideWidthMobile,
    slideWidthDesktop,
    childrenCount,
  }) => {
    return `
    display: grid;
    gap: ${theme.size[gapMobile]};
    grid-template-columns: repeat(${childrenCount}, calc(${slideWidthMobile}% - ${theme.size[gapMobile]}));
    margin-right: -${theme.size[gapMobile]};
    transform: translateX(-${activeSlideOffsetLeft}px);
    transition: transform .4s ease;

      @media (min-width: ${Breakpoints.b960}px) {
          gap: ${theme.size[gapDesktop]};
          margin-right: -${theme.size[gapDesktop]};
          grid-template-columns: repeat(${childrenCount}, calc(${slideWidthDesktop}% - ${theme.size[gapDesktop]}))
      }
    `;
  }
);

export const StyledAutoScrollItem = styled.div`
  display: flex;
  height: 100%;
  > div {
    max-width: -webkit-fill-available; 
  }
`;
